import path from 'path'

import fs from 'fs'

export function generateConfigFilePath(guideFolderPath: string) {
	return path.join(guideFolderPath, 'config.ts')
}

export function generateHashnodeConfigFilePath(rootDir: string) {
	return path.join(rootDir, 'hashnode.ts')
}

export function generateGuidesFolderPath(rootDir: string) {
	return path.join(rootDir, 'guides')
}

export function getAllGuideConfigs(guidesPath: string) {
	// Read all subdirectories in guides
	const guideFolders = fs.readdirSync(guidesPath).filter((folderName) => {
		const fullPath = path.join(guidesPath, folderName)
		return fs.lstatSync(fullPath).isDirectory()
	})

	return guideFolders
}

export function getGuideFolderFromEventPath(cwd: string, eventPath: string): string | null {
	const parts = eventPath.split('/') // Split the path by '/'
	const guidesIndex = parts.indexOf('guides') // Find the index of 'guides'

	if (guidesIndex !== -1 && guidesIndex + 1 < parts.length) {
		return `${generateGuidesFolderPath(cwd)}/${parts[guidesIndex + 1]}` // Return the folder after 'guides'
	}

	return null // Return null if 'guides' is not found or there is no folder after it
}
